export const getWRMStats = (): unknown => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};

	return { wrmStats };
};
